<template>
  <div class="loading-wrapper" :class="isCenterAligned ? 'center':''">
     <img class="loading-img" :src="spinnerUrl" alt="Loading Spinner">
  </div>
</template>

<script>
export default {
  name: "LoadingSpinnerSmall",
  props: {
    isCenterAligned: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      spinnerUrl: HH_COMPONENTS_URL + "/spinner.svg"
    };
  },
}
</script>

<style scoped>
.loading-wrapper {
  height: 100%;
  width: 100%;
}
.loading-wrapper img {
  height: 100px;
  width: auto;
}

.center {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.spinner {
  width: 30%;
  margin: 0 auto;
  color: #d5dde3;
}

</style>


// WEBPACK FOOTER //
// src/components/LoadingSpinnerSmall.vue